import PrimaryButton from 'components/buttons/PrimaryButton';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const CancelButton: FunctionComponent<Props> = ({
    className = '',
    isDisabled,
    onClick,
    testId = TEST_ID
}) => {
    const { CANCEL } = useTranslation();

    return (
        <PrimaryButton
            className={`${styles.button} ${className}`}
            isDisabled={isDisabled}
            onClick={onClick}
            testId={testId}
            text={CANCEL}
        />
    );
};

export default CancelButton;
